import $ from 'jquery';
import 'slick-carousel';

/**
 * Fixes the active dot indicator, because this is an unresolved bug in the slider
 * @param highlights
 * @param slide
 */
function fixDots(highlights, slide) {
	highlights.querySelectorAll('.slick-dots').forEach((dots) => {
		dots.querySelectorAll('li').forEach((dot, index) => {
			dot.classList.toggle('slick-active', index === slide)
		});
	});
}

document.querySelectorAll('.highlights').forEach((highlights) => {
	$(highlights).slick({
		dots: true,
		appendDots: '.navigation'
	}).on('afterChange', (e, slick, slide) => {
		fixDots(highlights, slide);
	});

	fixDots(highlights, 0);

	highlights.querySelectorAll('.arrow').forEach((arrow) => {
		arrow.addEventListener('click', (e) => {
			$(highlights).slick('slickNext')
		})
	})
})
